module.exports = __webpack_public_path__ + "static/alvaro.3430e089.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/quote_assets/alvaro.png
// module id = 1107
// module chunks = 35783957827783